import styled from "styled-components";

const StyledProductInsight = styled.div`
    &.frame-313284,
    &.frame-313284 * {
        box-sizing: border-box;
    }
    &.frame-313284 {
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        background-color: #1e2631;
        border-radius: 4px;
    }
    .frame-313288 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313293 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313310 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313286 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313327 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .heading-4-total-visitors {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        text-transform: uppercase;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .info-circle {
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        position: relative;
        overflow: visible;
    }
    .frame-313309 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313304 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 54px;
        position: relative;
    }
    .frame-313299 {
        border-radius: 4px;
        padding: 4px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313296 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313294 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-313298 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .luan-j-shirt-cosmic-4-3 {
        border-radius: 4px;
        flex-shrink: 0;
        width: 32px;
        height: 45px;
        position: relative;
        object-fit: cover;
    }
    .frame-313305 {
        display: flex;
        flex-direction: column;
        gap: 2px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .luan-j-shirt-14826 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 15px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    ._1-500-kr {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-3133052 {
        display: flex;
        flex-direction: column;
        gap: 2px;
        align-items: flex-end;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    ._5-6-k {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .sold {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-313327 i {
        font-size: 12px;
    }
`;

const ProductInsight = ({ title = "--", totalValue = "--", productInfo = {} }) => {
    return (
        <StyledProductInsight className="frame-313284">
            <div className="frame-313288">
                <div className="frame-313293">
                    <div className="frame-313310">
                        <div className="frame-313286">
                            <div className="frame-313327">
                                <div className="heading-4-total-visitors">{title}</div>{" "}
                                <i className="fa-light fa-circle-info"></i>
                            </div>
                        </div>
                        <div className="frame-313309">
                            <div className="frame-313304">
                                <div className="frame-313299">
                                    <div className="frame-313296">
                                        <div className="frame-313294">
                                            <div className="frame-313298">
                                                <img
                                                    className="luan-j-shirt-cosmic-4-3"
                                                    src={productInfo?.image}
                                                    alt=""
                                                />
                                                <div className="frame-313305">
                                                    <div className="luan-j-shirt-14826">{productInfo?.name}</div>
                                                    <div className="_1-500-kr">{`${productInfo?.price} ${productInfo?.amountCurrency}`}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="frame-3133052">
                                            <div className="_5-6-k">{totalValue}</div>
                                            <div className="sold">sold</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </StyledProductInsight>
    );
};
export default ProductInsight;
